let HOST = 'localhost';

if (typeof window !== 'undefined') {
  HOST = window?.location?.hostname;
}

type Environment = {
  ENV: string;
  SITE_HOST: string;
  APP_ROOT: string;
  API_ENDPOINTS: any;
  CHAT_ROOT: string;
  STATIC_ROOT: string;
  INSTAGRAM_CLIENT_ID: string;
};

const production: Environment = {
  ENV: 'production',
  SITE_HOST: HOST,
  APP_ROOT: 'https://app.getkarla.ai',
  API_ENDPOINTS: {
    KARLA_FLASK_API: 'https://api.getkarla.ai/v1',
    KARLA_AUTH_API: 'https://api.getkarla.ai/v1',
    KARLA_FLASK_ROOT: 'https://api.getkarla.ai',
  },
  CHAT_ROOT: 'https://chat.karlachat.com',
  STATIC_ROOT: 'https://static.getkarla.ai',
  INSTAGRAM_CLIENT_ID: '1265587488391111',
};

const stage: Environment = {
  ENV: 'staging',
  SITE_HOST: HOST,
  APP_ROOT: HOST === 'staging-app-getkarla.web.app' ? 'https://staging-app-getkarla.web.app' : 'https://app.staging.getkarla.ai',
  API_ENDPOINTS: {
    KARLA_FLASK_API: 'https://api.staging.getkarla.ai/v1',
    KARLA_FLASK_ROOT: 'https://api.staging.getkarla.ai',
    KARLA_AUTH_API: 'https://api.staging.getkarla.ai/v1',
  },
  CHAT_ROOT: 'https://karlachat-chat-staging.web.app',
  STATIC_ROOT: 'https://staging-static-getkarla.web.app',
  INSTAGRAM_CLIENT_ID: '1246921156760178',
};

const local: Environment = {
  ENV: 'local',
  SITE_HOST: HOST,
  APP_ROOT: 'https://localhost:3000',
  API_ENDPOINTS: {
    KARLA_AUTH_API: 'https://127.0.0.1:5051/v1',
    KARLA_FLASK_API: 'https://localhost:5050/v1',
    KARLA_FLASK_ROOT: 'https://localhost:5050',
    KARLA_AUTH_SERVER_API: 'https://localhost:5051',
  },
  CHAT_ROOT: 'https://localhost:3001',
  STATIC_ROOT: 'https://localhost:3002',
  INSTAGRAM_CLIENT_ID: '657587307352454',
};

const getConstant = (name: keyof Environment) => {
  switch (HOST) {
    case 'localhost':
      return local[name];
    case 'staging-app-getkarla.web.app':
    case 'app.staging.getkarla.ai':
      return stage[name];
    default:
      return production[name];
  }
};

export const ENV = getConstant('ENV');
export const SITE_HOST = getConstant('SITE_HOST');
export const APP_ROOT = getConstant('APP_ROOT');
export const API_ENDPOINTS = getConstant('API_ENDPOINTS');
export const CHAT_ROOT = getConstant('CHAT_ROOT');
export const STATIC_ROOT = getConstant('STATIC_ROOT');
export const INSTAGRAM_CLIENT_ID = getConstant('INSTAGRAM_CLIENT_ID');
